/*
 * Jira Ticket:
 * Created Date: Thu, 9th Jul 2020, 15:34:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const changeSubscriptionTierMutation = gql`
  mutation changeSubscriptionTier($input: ChangeSubscriptionTierInput!) {
    data: changeSubscriptionTier(input: $input) {
      approvalUrl
    }
  }
`;

export default ({ client, params }) => {
  try {
    return client.mutate({
      mutation: changeSubscriptionTierMutation,
      variables: {
        input: params,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
